var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { withRouter } from 'react-router';
import GAHelper from '../core/helpers/ga-helper';
import qs from 'qs';
var VirtualAnalyticsWrapper = /** @class */ (function (_super) {
    __extends(VirtualAnalyticsWrapper, _super);
    function VirtualAnalyticsWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VirtualAnalyticsWrapper.prototype.componentDidMount = function () {
        this.storeUtmParameters();
    };
    VirtualAnalyticsWrapper.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    };
    VirtualAnalyticsWrapper.prototype.onRouteChanged = function () {
        GAHelper.pageView(this.props.location.pathname);
    };
    VirtualAnalyticsWrapper.prototype.render = function () {
        return this.props.children;
    };
    VirtualAnalyticsWrapper.prototype.storeUtmParameters = function () {
        var _a, _b, _c, _d;
        if (!sessionStorage) {
            return;
        }
        var params = qs.parse(this.props.location.search.substr(1));
        if (!(params === null || params === void 0 ? void 0 : params.utm_source)) {
            return;
        }
        sessionStorage.setItem('gtagSettings', JSON.stringify({
            source: (_a = params === null || params === void 0 ? void 0 : params.utm_source) !== null && _a !== void 0 ? _a : null,
            medium: (_b = params === null || params === void 0 ? void 0 : params.utm_medium) !== null && _b !== void 0 ? _b : null,
            campaign: (_c = params === null || params === void 0 ? void 0 : params.utm_campaign) !== null && _c !== void 0 ? _c : null,
            content: (_d = params === null || params === void 0 ? void 0 : params.utm_content) !== null && _d !== void 0 ? _d : null,
        }));
    };
    return VirtualAnalyticsWrapper;
}(React.Component));
export default withRouter(VirtualAnalyticsWrapper);
